import { CodeHighlightNode, CodeNode } from "@lexical/code";
import { LinkNode } from "@lexical/link";
import { ListItemNode, ListNode } from "@lexical/list";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";

import { MentionNode } from "./MentionNode";

// The single registration list. Both RichTextEditor and every headless test
// read it: parseEditorState throws on a node type the editor does not know,
// so the two must never drift. Core nodes (root, paragraph, text, linebreak)
// are registered by Lexical itself and must not be listed here.
export const EDITOR_NODES = [
  HeadingNode,
  QuoteNode,
  ListNode,
  ListItemNode,
  LinkNode,
  CodeNode,
  CodeHighlightNode,
  MentionNode,
];
